import {InspectionUpdateStatus, Status} from "../../javaTypes";

function getBar(status: InspectionUpdateStatus, statusData: Status[]) {
    let count = statusData.filter(x => x === status.name).length;
    const perc = 100 * count / statusData.length;
    const title = `${Math.round(perc)}% ${status.displayName}`;
    let text;
    if (perc < 5) {
        text = ''
    } else if (perc < 25) {
        text = `${Math.round(perc)}%`;
    } else {
        text = title;
    }
    return <div className="progress-bar" hidden={count === 0} title={title} style={{width: `${perc}%`, backgroundColor: status.color, color: status.textWhite ? 'white' : 'black'}}>{text}</div>
}
/**
 * Returns a progress bar for each status
 * @param statusList The list of possible statuses
 * @param statusData The list of all team form statuses
 */
export default function StatusProgress({statusList, statusData} : {
    statusList: InspectionUpdateStatus[],
    statusData: Status[]
}) {
    if (!statusList || !statusList.length) return null;
    // Force NONE to end & PASS to beginning
    const reorderedStatuses = statusList.map((x,i) => Object.assign({}, {i: x.name === 'NONE' ? 99 : x.name === 'PASS' ? 0 : i}, x));
    reorderedStatuses.sort((a,b) => a.i - b.i);
    return <div className="progress">
        {reorderedStatuses.map(status => getBar(status, statusData))}
    </div>
}